import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { Provider } from "react-redux";
import store from "./context/store";
import { BrowserRouter } from "react-router-dom"; // ✅ Ensure only ONE Router

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <Provider store={store}>
      <BrowserRouter basename="/choppies">  {/* ✅ Add basename */}
        <App />
      </BrowserRouter>
    </Provider>
  </AuthProvider>
);
